export default __webpack_public_path__ + "static/media/Productions-J - Logo2.d865bd8f.png";